/* global Shopify */
/**
 * MAYAS Quick-Add Drawer - mobile-only hydration for <dialog id="mayas-quick-add-drawer">
 * Shell: snippets/mayas-quick-add-drawer.liquid
 *
 * PADS RULE 2026-09-24 (Marcus): the garment's own pads (variant metafields
 * custom.pad_standard / pad_light / pad_super) go into the cart with it through the
 * shared window.themeAddToCart (assets/theme-add-to-cart.js). The drawer shows one
 * read-only line ("N typer push-up pads følger gratis med"). The v2 pad picker, the v2
 * pads map read from main-product and the "Tilføj bundle" path are LEGACY: kept below
 * inside comments, not deleted, until v3 is live, every product has migrated and the
 * bundle products are hidden (Marcus).
 *
 * LEGACY header (v2):
 * Pads logic mirrors sections/main-product.liquid (lines 190-446) but reused via
 * /products/{handle} (full PDP) - extract data-pads-map. Section Rendering API
 * (?section_id=main-product) omits the additional-product block; full PDP has it.
 */
(function () {
  'use strict';

  var DIALOG_ID = 'mayas-quick-add-drawer';
  var MOBILE_MQ = '(max-width: 767px)';
  var REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';
  var BUNDLE_SMALL = 'alle-pads-typer';
  var BUNDLE_LARGE = 'alle-pads-typer-l-xl';
  var SMALL_SIZES = ['xs', 's', 'm'];
  var LARGE_SIZES = ['l', 'xl', 'xxl', '2xl', '3xl', 'xxxl'];

  var productCache = Object.create(null);      // handle -> product JSON
  var padsMapCache = Object.create(null);      // handle -> { variant_id: [pads] }
  var bundleCache = Object.create(null);       // handle -> bundle product JSON

  // i18n: read translated strings from data-* attrs on the dialog shell.
  // Fallbacks only hit if the snippet is loaded without attributes.
  function i18n(key, fallback) {
    var d = document.getElementById(DIALOG_ID);
    if (!d) return fallback;
    var v = d.getAttribute('data-mayas-i18n-' + key);
    return v == null || v === '' ? fallback : v;
  }

  // ---------- utils ----------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function isMobile() { return window.matchMedia(MOBILE_MQ).matches; }

  function money(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}} kr.'); } catch (e) { /* fall through */ }
    }
    try {
      return (cents / 100).toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' kr.';
    }
  }

  function unescapeHtml(raw) {
    var ta = document.createElement('textarea');
    ta.innerHTML = raw || '';
    return ta.value;
  }

  function normalize(s) { return String(s || '').trim().toLowerCase(); }

  // Right-size a Shopify CDN image URL (the .js payload hands back MASTER
  // urls — multi-MB originals). The drawer thumb renders at 70px, so ask
  // the CDN for 180px (~2.5x DPR) instead of the original.
  function sizedImage(src, width) {
    if (!src) return src;
    try {
      var u = new URL(src, window.location.origin);
      if (u.pathname.indexOf('/cdn/shop/') === -1 && u.hostname.indexOf('cdn.shopify.com') === -1) return src;
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function isSizeOptionName(name) {
    var n = normalize(name);
    return n === 'size' || n === 'størrelse' || n === 'storrelse';
  }
  function isColorOptionName(name) {
    var n = normalize(name);
    return n === 'color' || n === 'colour' || n === 'farve';
  }

  function findOptionIndex(product, matcher) {
    if (!product || !product.options) return -1;
    for (var i = 0; i < product.options.length; i++) {
      var opt = product.options[i];
      var nm = typeof opt === 'string' ? opt : (opt && opt.name);
      if (matcher(nm)) return i;
    }
    return -1;
  }

  // ---------- fetchers ----------
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (json) { productCache[handle] = json; return json; });
  }

  /* LEGACY (pads rule 2026-09-24): v2 pads map + bundle fetch, no longer called.
  function fetchPadsMap(handle) {
    if (padsMapCache[handle]) return Promise.resolve(padsMapCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var block = doc.querySelector('[data-additional-product-block]');
        if (!block) { padsMapCache[handle] = {}; return {}; }
        var raw = block.getAttribute('data-pads-map');
        if (!raw) { padsMapCache[handle] = {}; return {}; }
        try {
          var parsed = JSON.parse(unescapeHtml(raw));
          padsMapCache[handle] = parsed || {};
          return padsMapCache[handle];
        } catch (e) {
          console.warn('[mayas-qa] failed to parse pads map', e);
          padsMapCache[handle] = {};
          return {};
        }
      });
  }

  function fetchBundle(handle) {
    if (bundleCache[handle] === null) return Promise.resolve(null);
    if (bundleCache[handle]) return Promise.resolve(bundleCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('bundle ' + r.status); return r.json(); })
      .then(function (json) { bundleCache[handle] = json; return json; })
      .catch(function (err) {
        console.warn('[mayas-qa] bundle fetch error for handle', handle, err);
        bundleCache[handle] = null;
        return null;
      });
  }

  */

  // ---------- state ----------
  var state = null; // reset each open

  function variantByOptions(product, selected) {
    if (!product || !product.variants) return null;
    // selected: array matching product.options order, entries may be null (ignored)
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var opts = [v.option1, v.option2, v.option3];
      var match = true;
      for (var k = 0; k < selected.length; k++) {
        if (selected[k] == null) continue;
        if (opts[k] !== selected[k]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function variantStatus(v) {
    // returns { outOfStock, lowQty }
    if (!v) return { outOfStock: true, lowQty: 0 };
    var outOfStock = !v.available;
    if (!outOfStock && v.inventory_management && typeof v.inventory_quantity === 'number') {
      if (v.inventory_quantity <= 0 && v.inventory_policy !== 'continue') outOfStock = true;
    }
    var lowQty = 0;
    if (!outOfStock && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity <= 3) {
      lowQty = v.inventory_quantity;
    }
    return { outOfStock: outOfStock, lowQty: lowQty };
  }

  // ---------- render helpers ----------
  function setText(el, txt) { if (el) el.textContent = txt; }

  function renderHead(product) {
    var drawer = state.drawer;
    var imgWrap = $('[data-mayas-qa-img]', drawer);
    if (imgWrap) {
      var img = imgWrap.querySelector('img') || document.createElement('img');
      img.src = sizedImage(product.featured_image || (product.images && product.images[0]) || '', 180);
      img.alt = product.title || '';
      img.loading = 'lazy';
      if (!img.parentNode) imgWrap.appendChild(img);
    }
    setText($('[data-mayas-qa-title]', drawer), product.title || '');
    renderPrice(product);
  }

  function renderPrice(product) {
    var priceEl = $('[data-mayas-qa-price]', state.drawer);
    if (!priceEl) return;
    priceEl.innerHTML = '';
    var now = document.createElement('span');
    now.className = 'mayas-qa__price-now';
    now.textContent = money(product.price);
    priceEl.appendChild(now);
    if (product.compare_at_price && product.compare_at_price > product.price) {
      var was = document.createElement('s');
      was.className = 'mayas-qa__price-was';
      was.textContent = money(product.compare_at_price);
      priceEl.appendChild(was);
    }
    var ctaPrice = $('[data-mayas-qa-cta-price]', state.drawer);
    if (ctaPrice) ctaPrice.textContent = money(product.price);
  }

  function renderSwatches(product) {
    var wrap = $('[data-mayas-qa-swatches]', state.drawer);
    if (!wrap) return;
    wrap.innerHTML = '';
    var colorIdx = findOptionIndex(product, isColorOptionName);
    if (colorIdx < 0) { wrap.hidden = true; return; }
    var values = (product.options[colorIdx] && product.options[colorIdx].values) ||
                 (typeof product.options[colorIdx] === 'string' ? uniqueColorValues(product, colorIdx) : []);
    if (!values || values.length < 2) { wrap.hidden = true; return; }
    wrap.hidden = false;
    values.forEach(function (val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mayas-qa__sw';
      btn.setAttribute('role', 'radio');
      btn.dataset.color = val;
      btn.setAttribute('aria-label', val);
      btn.title = val;
      btn.style.setProperty('--mayas-qa-sw', val.toLowerCase().replace(/\s+/g, '-'));
      var dot = document.createElement('span');
      dot.className = 'mayas-qa__sw-dot';
      btn.appendChild(dot);
      btn.addEventListener('click', function () { selectColor(val); });
      wrap.appendChild(btn);
    });
    syncSwatchActive();
  }

  function uniqueColorValues(product, idx) {
    var seen = {}; var out = [];
    product.variants.forEach(function (v) {
      var val = [v.option1, v.option2, v.option3][idx];
      if (val && !seen[val]) { seen[val] = true; out.push(val); }
    });
    return out;
  }

  function syncSwatchActive() {
    var wrap = $('[data-mayas-qa-swatches]', state.drawer);
    if (!wrap) return;
    $all('.mayas-qa__sw', wrap).forEach(function (btn) {
      var active = btn.dataset.color === state.selectedColor;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-checked', active ? 'true' : 'false');
    });
  }

  function renderSizes() {
    var product = state.product;
    var wrap = $('[data-mayas-qa-sizes]', state.drawer);
    if (!wrap) return;
    wrap.innerHTML = '';
    var sizeIdx = findOptionIndex(product, isSizeOptionName);
    if (sizeIdx < 0) { wrap.hidden = true; return; }
    wrap.hidden = false;
    state.sizeIdx = sizeIdx;
    state.colorIdx = findOptionIndex(product, isColorOptionName);

    var sizeValues = (product.options[sizeIdx] && product.options[sizeIdx].values) ||
                     uniqueColorValues(product, sizeIdx); // same helper works
    sizeValues.forEach(function (sz) {
      var selected = [null, null, null];
      if (state.colorIdx >= 0) selected[state.colorIdx] = state.selectedColor;
      selected[sizeIdx] = sz;
      var v = variantByOptions(product, selected);
      var status = variantStatus(v);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mayas-qa__sz';
      btn.setAttribute('role', 'radio');
      btn.dataset.size = sz;
      if (status.outOfStock) btn.classList.add('is-out');
      if (status.lowQty) btn.classList.add('is-low');
      if (v && state.selectedVariantId === v.id) btn.classList.add('is-active');
      btn.setAttribute('aria-checked', btn.classList.contains('is-active') ? 'true' : 'false');
      var label = sz;
      if (status.lowQty) label += ' · ' + status.lowQty + ' ' + i18n('left', 'left');
      btn.textContent = label;
      btn.addEventListener('click', function () {
        if (!v) return;
        if (status.outOfStock) return;
        selectSize(sz);
      });
      wrap.appendChild(btn);
    });
  }

  /* Pads rule 2026-09-24: one read-only line with the number of pad types that follow
     the selected size. Count = the pads window.themeAddToCart will add. */
  function renderPads() {
    var section = $('[data-mayas-qa-padsline-section]', state.drawer);
    var line = $('[data-mayas-qa-padsline]', state.drawer);
    var text = $('[data-mayas-qa-padsline-text]', state.drawer);
    if (!section || !line || !text) return;
    var vid = state.selectedVariantId;
    var api = window.themeAddToCart && window.themeAddToCart.padsFor;
    if (!vid || !api) { section.hidden = true; return; }
    var s = state;
    api(vid, s.handle).then(function (pads) {
      if (state !== s || s.selectedVariantId !== vid) return;
      var count = (pads || []).length;
      if (!count) { section.hidden = true; return; }
      text.textContent = count === 1
        ? (line.getAttribute('data-label-one') || '')
        : (line.getAttribute('data-label-many') || '').replace('__N__', count);
      section.hidden = false;
    });
  }

  /* LEGACY (pads rule 2026-09-24): v2 pad picker + bundle card, no longer called.
  // Derive a short display name from the pad's full title.
  // "Standard pads - Nude (L-XXL)" → "STANDARD"
  // "Light push up pads - Nude (L-XXL)" → "LIGHT ↑"
  // "Super push up pads" → "SUPER ↑↑"
  function padShortName(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('super') === 0 || t.indexOf('super') >= 0 && t.indexOf('push') >= 0) return 'SUPER ↑↑';
    if (t.indexOf('light') >= 0) return 'LIGHT ↑';
    if (t.indexOf('standard') >= 0) return 'STANDARD';
    // fallback: first 2 words uppercased
    return (title || '').split(/\s+/).slice(0, 2).join(' ').toUpperCase();
  }

  function renderPads() {
    var section = $('[data-mayas-qa-pads-section]', state.drawer);
    var wrap = $('[data-mayas-qa-pads]', state.drawer);
    if (!section || !wrap) return;
    var pads = (state.padsMap && state.selectedVariantId) ? state.padsMap[String(state.selectedVariantId)] : null;
    if (!pads || !pads.length) {
      section.hidden = true;
      state.selectedPadVariantIds = [];
      return;
    }
    section.hidden = false;
    wrap.innerHTML = '';

    // Prune any previously-selected pad ids that no longer exist for this variant
    if (!Array.isArray(state.selectedPadVariantIds)) state.selectedPadVariantIds = [];
    state.selectedPadVariantIds = state.selectedPadVariantIds.filter(function (id) {
      return pads.some(function (p) { return String(p.variant_id) === String(id); });
    });
    // Default: first pad pre-selected if nothing selected yet
    if (state.selectedPadVariantIds.length === 0) {
      state.selectedPadVariantIds = [pads[0].variant_id];
    }

    pads.forEach(function (pad) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mayas-qa__pad';
      btn.setAttribute('role', 'checkbox');
      btn.dataset.padVariantId = pad.variant_id;
      btn.dataset.padPrice = pad.price;
      btn.dataset.padTitleFull = pad.title || '';
      btn.innerHTML =
        '<span class="mayas-qa__pad-title">' + padShortName(pad.title) + '</span>' +
        '<span class="mayas-qa__pad-price"></span>';
      btn.addEventListener('click', function () { togglePad(pad.variant_id); });
      wrap.appendChild(btn);
    });

    updatePadsDisplay();

    // sized-to text
    var sizedEl = $('[data-mayas-qa-pads-sized]', state.drawer);
    if (sizedEl) {
      var sizeLabel = state.selectedSize ? (' · ' + i18n('sized-to', 'Sized to size') + ' ' + state.selectedSize) : '';
      sizedEl.textContent = sizeLabel;
    }
  }

  // Recompute every pad card's active state + price label from selection order.
  // Rule: unselected → "Gratis" (teaser). First selected → "Gratis". Second+ → real price.
  function updatePadsDisplay() {
    var ids = Array.isArray(state.selectedPadVariantIds) ? state.selectedPadVariantIds : [];
    var freeLabel = i18n('free', 'Free');
    $all('.mayas-qa__pad', state.drawer).forEach(function (b) {
      var pvid = b.dataset.padVariantId;
      var i = ids.indexOf(pvid) >= 0 ? ids.indexOf(String(pvid)) : -1;
      // indexOf may miss due to string/number coercion - re-check as string:
      if (i < 0) {
        for (var k = 0; k < ids.length; k++) {
          if (String(ids[k]) === String(pvid)) { i = k; break; }
        }
      }
      var active = i >= 0;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-checked', active ? 'true' : 'false');
      var priceEl = b.querySelector('.mayas-qa__pad-price');
      if (priceEl) {
        if (!active) {
          priceEl.textContent = freeLabel;
        } else if (i === 0) {
          priceEl.textContent = freeLabel;
        } else {
          priceEl.textContent = b.dataset.padPrice;
        }
      }
    });
  }

  function renderBundle() {
    var wrap = $('[data-mayas-qa-bundle]', state.drawer);
    if (!wrap) return;
    var handle = bundleHandleForSize(state.selectedSize);
    if (!handle) { wrap.hidden = true; return; }
    fetchBundle(handle).then(function (bundle) {
      if (!bundle) {
        console.warn('[mayas-qa] bundle fetch failed for handle', handle);
        wrap.hidden = true;
        return;
      }
      if (!bundle.available) {
        console.warn('[mayas-qa] bundle unavailable for handle', handle);
        wrap.hidden = true;
        return;
      }
      var firstVariant = bundle.variants && bundle.variants[0];
      if (!firstVariant || !firstVariant.id) {
        console.warn('[mayas-qa] bundle has no variant for handle', handle);
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      state.bundleHandle = handle;
      state.bundleVariantId = firstVariant.id;
      var wasEl = $('[data-mayas-qa-bundle-was]', wrap);
      var nowEl = $('[data-mayas-qa-bundle-now]', wrap);
      if (nowEl) nowEl.textContent = money(bundle.price);
      if (wasEl) {
        if (bundle.compare_at_price && bundle.compare_at_price > bundle.price) {
          wasEl.hidden = false;
          wasEl.textContent = money(bundle.compare_at_price);
        } else {
          wasEl.hidden = true;
          wasEl.textContent = '';
        }
      }
    });
  }

  */

  /* LEGACY (pads rule 2026-09-24): size -> bundle handle, no longer called.
  // Extract the first size token from a size option string.
  // Examples:
  //   "S"              → "s"
  //   "S (XS-S)"       → "s"
  //   "2XL (XL-2XL)"   → "2xl"
  //   "XL"             → "xl"
  // Returns lowercased token or '' if none found.
  function sizeToken(sz) {
    var n = normalize(sz);
    if (!n) return '';
    // match leading digit(s) optionally followed by letters, or leading letters
    var m = n.match(/^([0-9]*[a-zæøå]+)/);
    return m ? m[1] : '';
  }

  function bundleHandleForSize(sz) {
    var token = sizeToken(sz);
    if (!token) return null;
    if (SMALL_SIZES.indexOf(token) >= 0) return BUNDLE_SMALL;
    if (LARGE_SIZES.indexOf(token) >= 0) return BUNDLE_LARGE;
    return null;
  }

  */

  // ---------- selection handlers ----------
  function recomputeVariant() {
    var selected = [null, null, null];
    if (state.colorIdx >= 0) selected[state.colorIdx] = state.selectedColor;
    if (state.sizeIdx >= 0) selected[state.sizeIdx] = state.selectedSize;
    var v = variantByOptions(state.product, selected);
    state.selectedVariantId = v ? v.id : null;
    // Update featured image if variant image differs
    if (v && v.featured_image && v.featured_image.src) {
      var imgWrap = $('[data-mayas-qa-img]', state.drawer);
      if (imgWrap) {
        var img = imgWrap.querySelector('img');
        if (img) img.src = sizedImage(v.featured_image.src, 180);
      }
    }
    // Update CTA price
    var ctaPrice = $('[data-mayas-qa-cta-price]', state.drawer);
    if (ctaPrice && v) ctaPrice.textContent = money(v.price);
  }

  function selectColor(color) {
    state.selectedColor = color;
    syncSwatchActive();
    // Pick first available size for this color if current one invalid
    var product = state.product;
    if (state.sizeIdx >= 0) {
      var currentSel = [null, null, null];
      currentSel[state.colorIdx] = color;
      currentSel[state.sizeIdx] = state.selectedSize;
      var cur = variantByOptions(product, currentSel);
      if (!cur || variantStatus(cur).outOfStock) {
        var sizes = product.options[state.sizeIdx].values || uniqueColorValues(product, state.sizeIdx);
        for (var i = 0; i < sizes.length; i++) {
          var sel = [null, null, null];
          sel[state.colorIdx] = color;
          sel[state.sizeIdx] = sizes[i];
          var vv = variantByOptions(product, sel);
          if (vv && !variantStatus(vv).outOfStock) { state.selectedSize = sizes[i]; break; }
        }
      }
    }
    recomputeVariant();
    renderSizes();
    renderPads();
    /* LEGACY: renderBundle(); */
  }

  function selectSize(sz) {
    state.selectedSize = sz;
    recomputeVariant();
    // re-render sizes to update aria/active
    $all('.mayas-qa__sz', state.drawer).forEach(function (b) {
      var active = b.dataset.size === sz;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    renderPads();
    /* LEGACY: renderBundle(); */
  }

  /* LEGACY (pads rule 2026-09-24): pad picker toggle, no longer called.
  function togglePad(padVariantId) {
    if (!Array.isArray(state.selectedPadVariantIds)) state.selectedPadVariantIds = [];
    var ids = state.selectedPadVariantIds;
    var idx = -1;
    for (var k = 0; k < ids.length; k++) {
      if (String(ids[k]) === String(padVariantId)) { idx = k; break; }
    }
    if (idx >= 0) ids.splice(idx, 1);
    else ids.push(padVariantId);
    updatePadsDisplay();
  }

  */

  // ---------- cart ----------
  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Add to cart failed'); });
      return r.json();
    });
  }

  function onSubmit() {
    if (!state.selectedVariantId) return;
    var btn = $('[data-mayas-qa-submit]', state.drawer);
    var labelEl = $('[data-mayas-qa-submit-label]', state.drawer);
    var origLabel = labelEl ? labelEl.textContent : '';
    if (btn) btn.disabled = true;
    if (labelEl) labelEl.textContent = i18n('adding', 'Adding…');
    hideError();
    /* Pads rule 2026-09-24: shared add = garment + its metafield pads in one call.
       LEGACY (v2 picker): items = garment + state.selectedPadVariantIds, kept only as the
       fallback below when the shared file did not load. */
    var add;
    if (typeof window.themeAddToCart === 'function') {
      add = window.themeAddToCart(state.selectedVariantId, { quantity: 1, source: 'quick_add', handle: state.handle, open: false });
    } else {
      var items = [{ id: state.selectedVariantId, quantity: 1 }];
      add = addToCart(items);
    }
    add.then(function () {
      closeAndOpenCart();
    }).catch(function (err) {
      showError(err && err.message ? err.message : i18n('error', 'Could not add to cart.'));
    }).then(function () {
      if (btn) btn.disabled = false;
      if (labelEl) labelEl.textContent = origLabel;
    });
  }

  /* LEGACY (pads rule 2026-09-24): "Tilføj bundle" submit, no longer bound.
  function onBundleSubmit() {
    if (!state.selectedVariantId || !state.bundleVariantId) return;
    var btn = $('[data-mayas-qa-bundle-cta]', state.drawer);
    if (btn) btn.disabled = true;
    hideError();
    var items = [
      { id: state.selectedVariantId, quantity: 1 },
      { id: state.bundleVariantId, quantity: 1 }
    ];
    addToCart(items).then(function () {
      closeAndOpenCart();
    }).catch(function (err) {
      showError(err && err.message ? err.message : i18n('error', 'Could not add bundle.'));
    }).then(function () { if (btn) btn.disabled = false; });
  }

  */

  function closeAndOpenCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    try { state.drawer.close(); } catch (e) { /* noop */ }
    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.show === 'function') {
        try { cartDrawer.show(); return; } catch (e) { /* fall through */ }
      }
      cartDrawer.setAttribute('open', '');
    }
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  function showError(msg) {
    var el = $('[data-mayas-qa-error]', state.drawer);
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  function hideError() {
    var el = $('[data-mayas-qa-error]', state.drawer);
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  // ---------- size finder ----------
  // Wair's embed doesn't expose a reliable global; it binds to #wair-fit-advisor on
  // the PDP. Simplest reliable path: navigate to the product page with a #wair hash
  // the PDP can use to auto-open the widget on load.
  function onSizeFinder() {
    if (!state || !state.handle) return;
    var url = (state.product && state.product.url) || ('/products/' + encodeURIComponent(state.handle));
    window.location.href = url + '#wair';
  }

  // ---------- open / init ----------
  function openDrawer(handle, variantId, trigger) {
    var drawer = document.getElementById(DIALOG_ID);
    if (!drawer) return;

    state = {
      drawer: drawer,
      handle: handle,
      trigger: trigger,
      product: null,
      padsMap: null,
      selectedColor: null,
      selectedSize: null,
      selectedVariantId: variantId ? parseInt(variantId, 10) : null,
      selectedPadVariantIds: [],
      sizeIdx: -1,
      colorIdx: -1,
      bundleHandle: null,
      bundleVariantId: null
    };

    // Reduced motion class
    try {
      drawer.classList.toggle('mayas-qa--no-motion', window.matchMedia(REDUCED_MOTION_MQ).matches);
    } catch (e) { /* noop */ }

    var loading = $('[data-mayas-qa-loading]', drawer);
    var content = $('[data-mayas-qa-content]', drawer);
    var errEl = $('[data-mayas-qa-error]', drawer);
    if (loading) loading.hidden = false;
    if (content) content.hidden = true;
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

    if (typeof drawer.showModal === 'function') {
      try { drawer.showModal(); } catch (e) { drawer.setAttribute('open', ''); }
    } else {
      drawer.setAttribute('open', '');
    }

    /* LEGACY: Promise.all([fetchProduct(handle), fetchPadsMap(handle)]) read the v2 pads map. */
    Promise.all([fetchProduct(handle)]).then(function (results) {
      var product = results[0];
      state.product = product;
      state.padsMap = {};

      // Resolve initial variant / color / size
      var initialVariant = null;
      if (state.selectedVariantId) {
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === state.selectedVariantId) { initialVariant = product.variants[i]; break; }
        }
      }
      if (!initialVariant) {
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j].available) { initialVariant = product.variants[j]; break; }
        }
      }
      if (!initialVariant && product.variants && product.variants.length) initialVariant = product.variants[0];

      state.colorIdx = findOptionIndex(product, isColorOptionName);
      state.sizeIdx = findOptionIndex(product, isSizeOptionName);
      if (initialVariant) {
        state.selectedVariantId = initialVariant.id;
        var opts = [initialVariant.option1, initialVariant.option2, initialVariant.option3];
        if (state.colorIdx >= 0) state.selectedColor = opts[state.colorIdx];
        if (state.sizeIdx >= 0) state.selectedSize = opts[state.sizeIdx];
      }

      renderHead(product);
      renderSwatches(product);
      renderSizes();
      recomputeVariant();
      renderPads();
      /* LEGACY: renderBundle(); */

      if (loading) loading.hidden = true;
      if (content) content.hidden = false;
    }).catch(function (err) {
      if (loading) loading.hidden = true;
      showError((err && err.message) || i18n('error', 'Could not load product.'));
    });
  }

  function bindDialogOnce() {
    var drawer = document.getElementById(DIALOG_ID);
    if (!drawer || drawer.__mayasQaBound) return;
    drawer.__mayasQaBound = true;

    var submitBtn = $('[data-mayas-qa-submit]', drawer);
    if (submitBtn) submitBtn.addEventListener('click', onSubmit);

    /* LEGACY (pads rule 2026-09-24): bundle button is commented out in the snippet.
    var bundleBtn = $('[data-mayas-qa-bundle-cta]', drawer);
    if (bundleBtn) bundleBtn.addEventListener('click', onBundleSubmit);
    */

    var sizeFinderBtn = $('[data-mayas-qa-sizefinder]', drawer);
    if (sizeFinderBtn) sizeFinderBtn.addEventListener('click', onSizeFinder);

    // Close resets state
    drawer.addEventListener('close', function () { state = null; });
  }

  // ---------- global click delegation ----------
  function onDocClick(e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-mayas-quick-add-trigger]') : null;
    if (!trigger) return;
    if (!isMobile()) return; // desktop: let <quick-buy-modal> handle it
    var handle = trigger.getAttribute('data-mayas-handle');
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    bindDialogOnce();
    openDrawer(handle, trigger.getAttribute('data-mayas-variant-id'), trigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindDialogOnce();
      document.addEventListener('click', onDocClick, true);
    });
  } else {
    bindDialogOnce();
    document.addEventListener('click', onDocClick, true);
  }
})();
